import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import messages from './reportsMessages';

const CollapseStatus = {
  SHOW: 1,
  COLLAPSING: 2,
  COLLAPSED: 3,
};

const SchoolCard = props => {
  const limit = 3;
  const [page, setPage] = useState(1);
  const [collapseStatus, setCollapseStatus] = useState({});
  const totalPages = Math.ceil(props.schools.length / limit);
  const schoolsPaginated = props.schools.slice((page - 1) * limit, limit);

  const collapse = ref => () => {
    const nextStatus = [CollapseStatus.SHOW, undefined].includes(collapseStatus[ref])
      ? CollapseStatus.COLLAPSED
      : CollapseStatus.SHOW;
    setCollapseStatus({ ...collapseStatus, [ref]: CollapseStatus.COLLAPSING });
    setTimeout(() => setCollapseStatus({ ...collapseStatus, [ref]: nextStatus }), 50);
  };

  useEffect(() => {
    if (props.schools) {
      setCollapseStatus({ ...collapseStatus, [props.schools.map(school => school.name)]: 3 });
    }
  }, [props.schools]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="card-title mb-3">
          <i className="pe-7s-graph1 mr-2" />
          <FormattedMessage {...messages.schools} />
        </div>
        <div className="accordion" id="accordionAudit">
          {schoolsPaginated.map(school => (
            <div className="row">
              <div className="col">
                <a
                  className="id mb-2 collapsed"
                  onClick={collapse(school.name)}
                  className={classNames({
                    collapsed: collapseStatus[school.name] === CollapseStatus.COLLAPSED,
                  })}
                  aria-expanded={CollapseStatus[school.name] === CollapseStatus.SHOW}
                >
                  {school.name}
                  <i className="fa fa-chevron-down ml-2" />
                </a>
                <div
                  className="collapse"
                  className={classNames({
                    collapsing: collapseStatus[school.name] === CollapseStatus.COLLAPSING,
                    'collapse show': collapseStatus[school.name] === CollapseStatus.SHOW,
                    collapse: collapseStatus[school.name] === CollapseStatus.COLLAPSED,
                  })}
                  id="collapseOne"
                >
                  {school.courses.map(course => (
                    <p className="mb-1">{course.name}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
          <hr className="mt-4 mb-3" />
          <div className="text-right">
            <div className="pagination">
              <a className="prev" onClick={() => setPage(page - 1 < 1 ? 1 : page - 1)}>
                <i className="fa fa-chevron-left" />
              </a>
              {page} <FormattedMessage {...messages.of} /> {totalPages}
              <a
                className="next"
                onClick={() => setPage(page + 1 > totalPages ? totalPages : page + 1)}
              >
                <i className="fa fa-chevron-right" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SchoolCard.propTypes = {};

SchoolCard.defaultProps = {
  schools: [],
};

export default SchoolCard;
